// @generated by protoc-gen-es v2.11.0 with parameter "ts_nocheck=true,target=ts"
// @generated from file breachwatch.proto (package BreachWatch, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file breachwatch.proto.
 */
export const file_breachwatch: GenFile =
  /*@__PURE__*/
  fileDesc(
    "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",
  );

/**
 * @generated from message BreachWatch.BreachWatchRecordRequest
 */
export type BreachWatchRecordRequest = Message<"BreachWatch.BreachWatchRecordRequest"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: bytes encryptedData = 2;
   */
  encryptedData: Uint8Array;

  /**
   * @generated from field: BreachWatch.BreachWatchInfoType breachWatchInfoType = 3;
   */
  breachWatchInfoType: BreachWatchInfoType;

  /**
   * @generated from field: bool updateUserWhoScanned = 4;
   */
  updateUserWhoScanned: boolean;
};

/**
 * Describes the message BreachWatch.BreachWatchRecordRequest.
 * Use `create(BreachWatchRecordRequestSchema)` to create a new message.
 */
export const BreachWatchRecordRequestSchema: GenMessage<BreachWatchRecordRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 0);

/**
 * @generated from message BreachWatch.BreachWatchUpdateRequest
 */
export type BreachWatchUpdateRequest = Message<"BreachWatch.BreachWatchUpdateRequest"> & {
  /**
   * @generated from field: repeated BreachWatch.BreachWatchRecordRequest breachWatchRecordRequest = 1;
   */
  breachWatchRecordRequest: BreachWatchRecordRequest[];

  /**
   * @generated from field: bytes encryptedData = 2;
   */
  encryptedData: Uint8Array;
};

/**
 * Describes the message BreachWatch.BreachWatchUpdateRequest.
 * Use `create(BreachWatchUpdateRequestSchema)` to create a new message.
 */
export const BreachWatchUpdateRequestSchema: GenMessage<BreachWatchUpdateRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 1);

/**
 * @generated from message BreachWatch.BreachWatchRecordStatus
 */
export type BreachWatchRecordStatus = Message<"BreachWatch.BreachWatchRecordStatus"> & {
  /**
   * @generated from field: bytes recordUid = 1;
   */
  recordUid: Uint8Array;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message BreachWatch.BreachWatchRecordStatus.
 * Use `create(BreachWatchRecordStatusSchema)` to create a new message.
 */
export const BreachWatchRecordStatusSchema: GenMessage<BreachWatchRecordStatus> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 2);

/**
 * @generated from message BreachWatch.BreachWatchUpdateResponse
 */
export type BreachWatchUpdateResponse = Message<"BreachWatch.BreachWatchUpdateResponse"> & {
  /**
   * @generated from field: repeated BreachWatch.BreachWatchRecordStatus breachWatchRecordStatus = 1;
   */
  breachWatchRecordStatus: BreachWatchRecordStatus[];
};

/**
 * Describes the message BreachWatch.BreachWatchUpdateResponse.
 * Use `create(BreachWatchUpdateResponseSchema)` to create a new message.
 */
export const BreachWatchUpdateResponseSchema: GenMessage<BreachWatchUpdateResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 3);

/**
 * @generated from message BreachWatch.BreachWatchTokenRequest
 */
export type BreachWatchTokenRequest = Message<"BreachWatch.BreachWatchTokenRequest"> & {
  /**
   * @generated from field: bytes breachWatchToken = 1;
   */
  breachWatchToken: Uint8Array;
};

/**
 * Describes the message BreachWatch.BreachWatchTokenRequest.
 * Use `create(BreachWatchTokenRequestSchema)` to create a new message.
 */
export const BreachWatchTokenRequestSchema: GenMessage<BreachWatchTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 4);

/**
 * @generated from message BreachWatch.BreachWatchTokenResponse
 */
export type BreachWatchTokenResponse = Message<"BreachWatch.BreachWatchTokenResponse"> & {
  /**
   * @generated from field: bytes breachWatchToken = 1;
   */
  breachWatchToken: Uint8Array;

  /**
   * @generated from field: bool clientEncrypted = 2;
   */
  clientEncrypted: boolean;
};

/**
 * Describes the message BreachWatch.BreachWatchTokenResponse.
 * Use `create(BreachWatchTokenResponseSchema)` to create a new message.
 */
export const BreachWatchTokenResponseSchema: GenMessage<BreachWatchTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 5);

/**
 * @generated from message BreachWatch.AnonymizedTokenResponse
 */
export type AnonymizedTokenResponse = Message<"BreachWatch.AnonymizedTokenResponse"> & {
  /**
   * @generated from field: bytes domainToken = 1;
   */
  domainToken: Uint8Array;

  /**
   * @generated from field: bytes emailToken = 2;
   */
  emailToken: Uint8Array;

  /**
   * @generated from field: bytes passwordToken = 3;
   */
  passwordToken: Uint8Array;
};

/**
 * Describes the message BreachWatch.AnonymizedTokenResponse.
 * Use `create(AnonymizedTokenResponseSchema)` to create a new message.
 */
export const AnonymizedTokenResponseSchema: GenMessage<AnonymizedTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 6);

/**
 * @generated from message BreachWatch.HashCheck
 */
export type HashCheck = Message<"BreachWatch.HashCheck"> & {
  /**
   * @generated from field: bytes hash1 = 1;
   */
  hash1: Uint8Array;

  /**
   * @generated from field: bytes euid = 2;
   */
  euid: Uint8Array;
};

/**
 * Describes the message BreachWatch.HashCheck.
 * Use `create(HashCheckSchema)` to create a new message.
 */
export const HashCheckSchema: GenMessage<HashCheck> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 7);

/**
 * @generated from message BreachWatch.BreachWatchStatusRequest
 */
export type BreachWatchStatusRequest = Message<"BreachWatch.BreachWatchStatusRequest"> & {
  /**
   * @generated from field: bytes anonymizedToken = 1;
   */
  anonymizedToken: Uint8Array;

  /**
   * @generated from field: repeated BreachWatch.HashCheck hashCheck = 2;
   */
  hashCheck: HashCheck[];

  /**
   * @generated from field: repeated bytes removedEuid = 3;
   */
  removedEuid: Uint8Array[];
};

/**
 * Describes the message BreachWatch.BreachWatchStatusRequest.
 * Use `create(BreachWatchStatusRequestSchema)` to create a new message.
 */
export const BreachWatchStatusRequestSchema: GenMessage<BreachWatchStatusRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 8);

/**
 * @generated from message BreachWatch.HashStatus
 */
export type HashStatus = Message<"BreachWatch.HashStatus"> & {
  /**
   * @generated from field: bytes hash1 = 1;
   */
  hash1: Uint8Array;

  /**
   * @generated from field: bytes euid = 2;
   */
  euid: Uint8Array;

  /**
   * @generated from field: bool breachDetected = 3;
   */
  breachDetected: boolean;
};

/**
 * Describes the message BreachWatch.HashStatus.
 * Use `create(HashStatusSchema)` to create a new message.
 */
export const HashStatusSchema: GenMessage<HashStatus> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 9);

/**
 * @generated from message BreachWatch.BreachWatchStatusResponse
 */
export type BreachWatchStatusResponse = Message<"BreachWatch.BreachWatchStatusResponse"> & {
  /**
   * @generated from field: repeated BreachWatch.HashStatus hashStatus = 2;
   */
  hashStatus: HashStatus[];
};

/**
 * Describes the message BreachWatch.BreachWatchStatusResponse.
 * Use `create(BreachWatchStatusResponseSchema)` to create a new message.
 */
export const BreachWatchStatusResponseSchema: GenMessage<BreachWatchStatusResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 10);

/**
 * @generated from message BreachWatch.EnterprisePublicKeyResponse
 */
export type EnterprisePublicKeyResponse = Message<"BreachWatch.EnterprisePublicKeyResponse"> & {
  /**
   * @generated from field: bytes enterprisePublicKey = 1;
   */
  enterprisePublicKey: Uint8Array;

  /**
   * @generated from field: bytes enterpriseECCPublicKey = 2;
   */
  enterpriseECCPublicKey: Uint8Array;
};

/**
 * Describes the message BreachWatch.EnterprisePublicKeyResponse.
 * Use `create(EnterprisePublicKeyResponseSchema)` to create a new message.
 */
export const EnterprisePublicKeyResponseSchema: GenMessage<EnterprisePublicKeyResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 11);

/**
 * @generated from message BreachWatch.FreeScanRequest
 */
export type FreeScanRequest = Message<"BreachWatch.FreeScanRequest"> & {
  /**
   * @generated from field: bytes hashedEmail = 1;
   */
  hashedEmail: Uint8Array;
};

/**
 * Describes the message BreachWatch.FreeScanRequest.
 * Use `create(FreeScanRequestSchema)` to create a new message.
 */
export const FreeScanRequestSchema: GenMessage<FreeScanRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 12);

/**
 * @generated from message BreachWatch.FreeScanResponse
 */
export type FreeScanResponse = Message<"BreachWatch.FreeScanResponse"> & {
  /**
   * @generated from field: int32 emailBreaches = 1;
   */
  emailBreaches: number;

  /**
   * @generated from field: int32 passwordBreaches = 2;
   */
  passwordBreaches: number;
};

/**
 * Describes the message BreachWatch.FreeScanResponse.
 * Use `create(FreeScanResponseSchema)` to create a new message.
 */
export const FreeScanResponseSchema: GenMessage<FreeScanResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 13);

/**
 * @generated from message BreachWatch.PaidUserRequest
 */
export type PaidUserRequest = Message<"BreachWatch.PaidUserRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message BreachWatch.PaidUserRequest.
 * Use `create(PaidUserRequestSchema)` to create a new message.
 */
export const PaidUserRequestSchema: GenMessage<PaidUserRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 14);

/**
 * @generated from message BreachWatch.PaidUserResponse
 */
export type PaidUserResponse = Message<"BreachWatch.PaidUserResponse"> & {
  /**
   * @generated from field: bool paidUser = 1;
   */
  paidUser: boolean;
};

/**
 * Describes the message BreachWatch.PaidUserResponse.
 * Use `create(PaidUserResponseSchema)` to create a new message.
 */
export const PaidUserResponseSchema: GenMessage<PaidUserResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 15);

/**
 * @generated from message BreachWatch.DetailedScanRequest
 */
export type DetailedScanRequest = Message<"BreachWatch.DetailedScanRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message BreachWatch.DetailedScanRequest.
 * Use `create(DetailedScanRequestSchema)` to create a new message.
 */
export const DetailedScanRequestSchema: GenMessage<DetailedScanRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 16);

/**
 * @generated from message BreachWatch.UseOneTimeTokenRequest
 */
export type UseOneTimeTokenRequest = Message<"BreachWatch.UseOneTimeTokenRequest"> & {
  /**
   * @generated from field: bytes token = 1;
   */
  token: Uint8Array;
};

/**
 * Describes the message BreachWatch.UseOneTimeTokenRequest.
 * Use `create(UseOneTimeTokenRequestSchema)` to create a new message.
 */
export const UseOneTimeTokenRequestSchema: GenMessage<UseOneTimeTokenRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 17);

/**
 * @generated from message BreachWatch.BreachEvent
 */
export type BreachEvent = Message<"BreachWatch.BreachEvent"> & {
  /**
   * @generated from field: string site = 1;
   */
  site: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: bool passwordInBreach = 3;
   */
  passwordInBreach: boolean;

  /**
   * @generated from field: string date = 4;
   */
  date: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message BreachWatch.BreachEvent.
 * Use `create(BreachEventSchema)` to create a new message.
 */
export const BreachEventSchema: GenMessage<BreachEvent> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 18);

/**
 * @generated from message BreachWatch.UseOneTimeTokenResponse
 */
export type UseOneTimeTokenResponse = Message<"BreachWatch.UseOneTimeTokenResponse"> & {
  /**
   * @generated from field: int32 emailBreaches = 1;
   */
  emailBreaches: number;

  /**
   * @generated from field: int32 passwordBreaches = 2;
   */
  passwordBreaches: number;

  /**
   * @generated from field: repeated BreachWatch.BreachEvent breachEvents = 3;
   */
  breachEvents: BreachEvent[];

  /**
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message BreachWatch.UseOneTimeTokenResponse.
 * Use `create(UseOneTimeTokenResponseSchema)` to create a new message.
 */
export const UseOneTimeTokenResponseSchema: GenMessage<UseOneTimeTokenResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 19);

/**
 * @generated from message BreachWatch.OneTimeUseToken
 */
export type OneTimeUseToken = Message<"BreachWatch.OneTimeUseToken"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string pad = 2;
   */
  pad: string;
};

/**
 * Describes the message BreachWatch.OneTimeUseToken.
 * Use `create(OneTimeUseTokenSchema)` to create a new message.
 */
export const OneTimeUseTokenSchema: GenMessage<OneTimeUseToken> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 20);

/**
 * @generated from message BreachWatch.FreePasswordScanRequest
 */
export type FreePasswordScanRequest = Message<"BreachWatch.FreePasswordScanRequest"> & {
  /**
   * @generated from field: bytes hashedPassword = 1;
   */
  hashedPassword: Uint8Array;
};

/**
 * Describes the message BreachWatch.FreePasswordScanRequest.
 * Use `create(FreePasswordScanRequestSchema)` to create a new message.
 */
export const FreePasswordScanRequestSchema: GenMessage<FreePasswordScanRequest> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 21);

/**
 * @generated from message BreachWatch.FreePasswordScanResponse
 */
export type FreePasswordScanResponse = Message<"BreachWatch.FreePasswordScanResponse"> & {
  /**
   * @generated from field: int64 passwordBreaches = 1;
   */
  passwordBreaches: bigint;
};

/**
 * Describes the message BreachWatch.FreePasswordScanResponse.
 * Use `create(FreePasswordScanResponseSchema)` to create a new message.
 */
export const FreePasswordScanResponseSchema: GenMessage<FreePasswordScanResponse> =
  /*@__PURE__*/
  messageDesc(file_breachwatch, 22);

/**
 * @generated from enum BreachWatch.BreachWatchInfoType
 */
export enum BreachWatchInfoType {
  /**
   * @generated from enum value: RECORD = 0;
   */
  RECORD = 0,

  /**
   * @generated from enum value: ALTERNATE_PASSWORD = 1;
   */
  ALTERNATE_PASSWORD = 1,
}

/**
 * Describes the enum BreachWatch.BreachWatchInfoType.
 */
export const BreachWatchInfoTypeSchema: GenEnum<BreachWatchInfoType> =
  /*@__PURE__*/
  enumDesc(file_breachwatch, 0);
